<template>
  <div class="c-profile-cards__card c-profile-cards__card--privacy tile">
    <Checkbox
      :text="
        $t('Desidero ricevere informazioni realtive ad iniziative di marketing')
      "
      class="c-profile-cards__privacy__checkbox"
      v-model="privacy.marketing"
    />
    <Checkbox
      class="c-profile-cards__privacy__checkbox"
      :text="$t('Acconsento alla profilazione delle mie abitudini')"
      v-model="privacy.profilation"
    />
    <Checkbox
      class="c-profile-cards__privacy__checkbox"
      :text="
        $t(
          'Desidero ricevere informazioni relative ad iniziative di marketing di terze parti'
        )
      "
      v-model="privacy.third"
    />
    <Checkbox
      class="c-profile-cards__privacy__checkbox"
      :text="
        $t('Acconsento alla profilazione delle mie abitudini da terze parti')
      "
      v-model="privacy.third_profilation"
    />
    <div class="c-profile-cards__privacy">
      <button
        @click="removeAccount"
        class="btn primary c-profile-cards__privacy__delete"
        v-if="!getUser.remove_requested_at"
      >
        <i class="far fa-trash-alt"></i>
        <span>{{ $t("Elimina il mio account") }}</span>
      </button>
      <button
        @click="undoRemove"
        class="btn primary c-profile-cards__privacy__delete"
        v-else
      >
        <i class="fas fa-undo"></i>
        <span>{{ $t("Ripristina il mio account") }}</span>
      </button>
      <div class="btn-wrapper">
        <button
          v-if="attributesAreSame"
          class="btn btn-primary c-profile-cards__save"
          @click="updateConsent"
        >
          {{ $t("Aggiorna") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Checkbox from "./Checkbox";
import { GlobalService } from "@/common/services/api.service.js";
import { Mutations, Actions } from "@/store/global/global.types.js";

import { mapGetters } from "vuex";
import _ from "lodash";
export default {
  name: "PrivacyTab",
  components: {
    Checkbox
  },
  computed: {
    ...mapGetters(["getUser"]),
    attributesAreSame() {
      return !_.isEqual(this.privacy, this.privacyFromBE);
    }
  },
  data() {
    return {
      privacy: {
        marketing: false,
        profilation: false,
        third: false,
        third_profilation: false
      },
      privacyFromBE: {}
    };
  },
  methods: {
    async updateConsent() {
      this.$store.commit(Mutations.SHOW_SPINNER);
      try {
        await GlobalService.updateConsents({ agreements: this.privacy });
      } catch (e) {
        let errorResponse = _.get(e, "response", 0);
        switch (errorResponse.status) {
          case 422:
            this.$store.commit("pushMessage", {
              type: "waiting",
              title: this.$i18n.t("Dati non validi"),
              text: this.$i18n.t(
                "Controlla il formato dei dati inseriti e riprova"
              )
            });
            break;
          default:
            this.$store.commit("pushMessage", {
              type: "error",
              title: this.$i18n.t("Errore"),
              text: this.$i18n.t("Si è verificato un errore")
            });
            break;
        }
      }
      this.$store.commit(Mutations.HIDE_SPINNER);
    },
    removeAccount() {
      this.$emit("input", true);
    },
    async undoRemove() {
      this.$store.commit(Mutations.SHOW_SPINNER);
      try {
        await GlobalService.undoDeleteAccount();
        await this.$store.dispatch(Actions.GET_USER_PROFILE);
      } catch (e) {
        console.log(e);
        this.$store.commit("pushMessage", {
          type: "error",
          title: "Error",
          text: "An error occurred"
        });
      }
      this.$store.commit(Mutations.HIDE_SPINNER);
    }
  },
  watch: {
    getUser: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val.id) {
          const { marketing, profilation, third_profilation, third } = val;
          this.privacy = { marketing, profilation, third_profilation, third };
          this.privacyFromBE = {
            marketing,
            profilation,
            third_profilation,
            third
          };
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.c-profile-cards__card--privacy {
  text-align: left;
  align-items: start;
  @media (min-width: 992px) {
    padding: 45px 70px;
  }
}
.c-profile-cards__privacy__delete {
  .fa-trash-alt,
  .fa-undo {
    margin-right: 10px;
  }
}
</style>
